import { jsx, jsxs } from 'react/jsx-runtime';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import { ReactComponent as SvgError } from '../../shared/assets/error.js';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import 'ethers';
import '../../shared/consts/index.js';
import { Icon } from '../Icon/Icon.js';
import { Typography } from '../Typography/Typography.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';

const errorIconMap = {
    error: jsx(SvgError, {}),
};
const Alert = ({ children, icon, variant = 'error', contentDataTestId, }) => (jsxs("div", Object.assign({ className: classNames('alert', {
        'alert--error': variant === 'error',
        'alert--warning': variant === 'warning',
    }) }, { children: [icon && (jsx(Icon, Object.assign({ size: 'small', className: 'alert__icon' }, { children: typeof icon === 'string' ? errorIconMap[icon] : icon }))), jsx(Typography, Object.assign({ variant: 'body_small', "data-testid": contentDataTestId }, { children: children }))] })));

export { Alert };
